import type { TranscriptLine } from "shared/components/CallTranscript";

export const TRANSCRIPT_UNAVAILABLE = "Transcript unavailable";
export const MARK_AS_HEARD_LABEL = "Mark as heard";
export const MARK_AS_HEARD_FAILED_TOAST =
  "Couldn't mark the voicemail as heard. Try again.";

// A voicemail has one speaker, so its transcript reads as one paragraph.
export const voicemailTranscriptText = (
  lines: TranscriptLine[] | null | undefined
): string =>
  (lines ?? [])
    .map((line) => line.message.trim())
    .filter(Boolean)
    .join(" ");
